module.exports = __webpack_public_path__ + "img/arch-sup.2ea3816a.svg";